module.exports = __webpack_public_path__ + "svg/dice-orange.svg?11728fd65d76c2438be61b4643b70998";